import { EventEmitter } from 'eventemitter3';

export const appEventEmitter = new EventEmitter();

// Define event names for clarity
export const AUTH_ERROR_EVENT = 'authError';
export const FETCH_ERROR_EVENT = 'fetchError';
